import axios from "axios";

const api = axios.create({
  baseURL: "https://api.inversioneslactium.com/api", // Asegúrate de que este sea el puerto correcto de tu API
});

// Interceptor para añadir el token a las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    console.log(token);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// --- Auth ---
export const login = async (username, password) => {
  const { data } = await api.post("/users/login", { username, password });
  if (data.token) {
    localStorage.setItem("token", data.token);
  }
  return data;
};

export const logout = () => {
  localStorage.removeItem("token");
};

// Obtener usuario actual (admin) usando el endpoint protegido /users/me
export const getCurrentUser = () => api.get("/users/me");
export const updateMyProfile = (data) => api.put("/users/me", data);

// --- Sellers ---
export const getSellers = (params = {}) => api.get("/sellers", { params });
export const getSellerList = () => api.get("/sellers/list");
export const createSeller = (sellerData) => api.post("/sellers", sellerData);
export const updateSeller = (id, sellerData) =>
  api.put(`/sellers/${id}`, sellerData);
export const deleteSeller = (id) => api.delete(`/sellers/${id}`);

export const getQueseros = (params = {}) => api.get("/queseros", { params });
export const createQuesero = (data) => api.post("/queseros", data);
export const updateQuesero = (id, data) => api.put(`/queseros/${id}`, data);
export const deleteQuesero = (id) => api.delete(`/queseros/${id}`);

// --- Clients ---
export const getClients = (params = {}) => api.get("/clients", { params });
export const getClient = (id) => api.get(`/clients/${id}`);
export const getClientList = () => api.get("/clients/list");
export const createClient = (clientData) => api.post("/clients", clientData);
export const updateClient = (id, clientData) =>
  api.put(`/clients/${id}`, clientData);
export const deleteClient = (id) => api.delete(`/clients/${id}`);

// --- Products ---
export const getProducts = (params = {}) => api.get("/products", { params });
export const createProduct = (productData) =>
  api.post("/products", productData);
export const updateProduct = (id, productData) =>
  api.put(`/products/${id}`, productData);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// --- Invoices ---
export const getInvoices = (params = {}) => api.get("/invoices", { params });
export const createInvoice = (invoiceData) =>
  api.post("/invoices", invoiceData);
export const getNextInvoiceReference = () => api.get("/invoices/next-reference");
export const updateInvoice = (id, invoiceData) =>
  api.put(`/invoices/${id}`, invoiceData);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);
export const getInvoicePayments = (invoiceId) =>
  api.get(`/invoices/${invoiceId}/payments`);
export const addPaymentToInvoice = (invoiceId, paymentData) =>
  api.post(`/invoices/${invoiceId}/payments`, paymentData);
export const updateInvoicePayment = (invoiceId, paymentId, paymentData) =>
  api.put(`/invoices/${invoiceId}/payments/${paymentId}`, paymentData);
export const deleteInvoicePayment = (invoiceId, paymentId) =>
  api.delete(`/invoices/${invoiceId}/payments/${paymentId}`);

// --- Payments ---
export const getPaymentMethods = () => api.get("/payment-methods");
// La API no tiene un endpoint para obtener todos los pagos directamente, se obtienen a través de las facturas.

// --- BCV Rate ---
export const getBcvRate = () => api.get("/bcv-rates");

// --- Historical Rates ---
export const getHistoricalRates = () => api.get("/bcv-rates/history");

// --- Dashboard ---
export const getDashboardStats = () => api.get("/dashboard/stats");

// --- Providers ---
export const getProviders = (params = {}) => api.get("/providers", { params });
export const getProviderList = () => api.get("/providers/list");
export const getProvider = (id) => api.get(`/providers/${id}`);
export const createProvider = (providerData) => api.post("/providers", providerData);
export const updateProvider = (id, providerData) => api.put(`/providers/${id}`, providerData);
export const deleteProvider = (id) => api.delete(`/providers/${id}`);

// --- Milk Deliveries ---
export const getMilkDeliveries = (params = {}) => api.get("/milk-deliveries", { params });
export const getMilkDeliverySummary = (params = {}) => api.get("/milk-deliveries/summary", { params });
export const createMilkDelivery = (deliveryData) => api.post("/milk-deliveries", deliveryData);
export const upsertMilkDelivery = (deliveryData) => api.put("/milk-deliveries/upsert", deliveryData);
export const upsertMilkDayTrips = (data) => api.put("/milk-deliveries/day-trips", data);
export const updateMilkDelivery = (id, deliveryData) => api.put(`/milk-deliveries/${id}`, deliveryData);
export const deleteMilkDelivery = (id) => api.delete(`/milk-deliveries/${id}`);

// --- Milk Closures ---
export const getMilkClosures = () => api.get("/milk-closures");
export const createMilkClosure = (data) => api.post("/milk-closures", data);
export const deleteMilkClosure = (id) => api.delete(`/milk-closures/${id}`);

// --- Milk Settings ---
export const getMilkSettings = () => api.get("/milk-settings");
export const updateMilkSettings = (data) => api.put("/milk-settings", data);

// --- Milk provider payments ---
export const getMilkProviderPayments = (params = {}) =>
  api.get("/milk-provider-payments", { params });
export const createMilkProviderPayment = (data) =>
  api.post("/milk-provider-payments", data);
export const deleteMilkProviderPayment = (id) =>
  api.delete(`/milk-provider-payments/${id}`);
export const getPaymentEmitSources = () =>
  api.get("/milk-provider-payments/emit-sources");
export const createPaymentEmitSource = (data) =>
  api.post("/milk-provider-payments/emit-sources", data);

export const upsertMilkWeekPrice = (data) => api.put("/milk-week-prices", data);

// --- Cheese productions ---
export const getCheeseSummary = (params = {}) =>
  api.get("/cheese-productions/summary", { params });
export const createCheeseProduction = (data) =>
  api.post("/cheese-productions", data);
export const updateCheeseProduction = (id, data) =>
  api.put(`/cheese-productions/${id}`, data);
export const deleteCheeseProduction = (id) =>
  api.delete(`/cheese-productions/${id}`);

// --- Cheese maturations ---
export const getCheeseMaturations = (params = {}) =>
  api.get("/cheese-maturations", { params });
export const getCheeseMaturationOptions = (params = {}) =>
  api.get("/cheese-maturations/options", { params });
export const createCheeseMaturation = (data) =>
  api.post("/cheese-maturations", data);
export const updateCheeseMaturation = (id, data) =>
  api.put(`/cheese-maturations/${id}`, data);
export const exitCheeseMaturation = (id, data) =>
  api.post(`/cheese-maturations/${id}/exit`, data);
export const deleteCheeseMaturation = (id) =>
  api.delete(`/cheese-maturations/${id}`);

// --- Backup ---
export const getBackupInfo = () => api.get("/backup");
export const downloadBackup = () =>
  api.get("/backup/download", {
    responseType: "blob",
    timeout: 10 * 60 * 1000,
  });
export const restoreBackup = (file, confirm) => {
  const form = new FormData();
  form.append("file", file);
  form.append("confirm", confirm);
  return api.post("/backup/restore", form, {
    timeout: 10 * 60 * 1000,
  });
};
export const sendBackupToTelegram = () =>
  api.post("/backup/telegram", null, {
    timeout: 10 * 60 * 1000,
  });

export const getInvoiceActivity = (params = {}) =>
  api.get("/invoice-activity", { params });

// --- Notifications ---
export const getNotifications = (params = {}) =>
  api.get("/notifications", { params });
export const getNotificationUnreadCount = () =>
  api.get("/notifications/unread-count");
export const pushAdminNotification = (data) =>
  api.post("/notifications/push", data);
export const markNotificationRead = (id) =>
  api.put(`/notifications/${id}/read`);
export const markAllNotificationsRead = () =>
  api.put("/notifications/read-all");

// --- Payroll / Nómina ---
export const getEmployees = (params = {}) => api.get("/employees", { params });
export const getEmployeeList = () => api.get("/employees/list");
export const getEmployee = (id) => api.get(`/employees/${id}`);
export const createEmployee = (data) => api.post("/employees", data);
export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);
export const getPayrollSummary = (params = {}) => api.get("/payroll/summary", { params });
export const upsertPayrollPeriod = (data) => api.put("/payroll/periods", data);
export const getEmployeeAdvances = (params = {}) => api.get("/payroll/advances", { params });
export const createEmployeeAdvance = (data) => api.post("/payroll/advances", data);
export const deleteEmployeeAdvance = (id) => api.delete(`/payroll/advances/${id}`);

// --- Gastos de quesera ---
export const getQueseraExpenses = (params = {}) =>
  api.get("/expenses", { params });
export const getExpenseCategories = () => api.get("/expenses/categories");
export const createExpenseCategory = (data) => api.post("/expenses/categories", data);
export const createQueseraExpense = (data) => api.post("/expenses", data);
export const updateQueseraExpense = (id, data) => api.put(`/expenses/${id}`, data);
export const deleteQueseraExpense = (id) => api.delete(`/expenses/${id}`);

export default api;
